<template>
  <div class="classify">
    <ul>
      <router-link tag="li" :to="'/goods/' + item.id" class="classify-content icon_1" v-for="item in ilist" :key="item.id">
        <i class="iconfont" v-html="item.icon"></i>
        <p>{{item.name}}</p>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SlistIcons',
  props: {
    ilist: Array
  }
}
</script>

<style scoped>
.classify{ padding: 10px 15px; padding-bottom: 15px; font-size: 14px; border-top: 10px solid #f6f6f6;border-bottom: 10px solid #f6f6f6; background: url(/static/img/background2.jpg),url(/static/img/background5.png); background-repeat: no-repeat no-repeat; background-size: 100% 180px,100% 260px;}
.classify ul{ list-style-type: none; display: flex; flex-wrap: wrap;}
.classify .classify-content{ width: 25%; text-align: center; padding-top: 5px;}
.classify .classify-content .iconfont{ font-size: 20px;}
.classify .classify-content p{ color: #333; font-size: 12px; padding-top: 2px;}
.classify li:nth-child(1) .iconfont{ color: #f8534f;}
.classify li:nth-child(2) .iconfont{ color: #3dd4f3;}
.classify li:nth-child(3) .iconfont{ color: #674cf1;}
.classify li:nth-child(4) .iconfont{ color: #f7a400;}
.classify li:nth-child(5) .iconfont{ color: #cb3af7;}
.classify li:nth-child(6) .iconfont{ color: #00d5af;}
.classify li:nth-child(7) .iconfont{ color: #ffa40f;}
.classify li:nth-child(8) .iconfont{ color: #ee4147;}
.classify li:nth-child(9) .iconfont{ color: #9e7fdc;}
.classify li:nth-child(10) .iconfont{ color: #ff5172;}
.classify li:nth-child(11) .iconfont{ color: #0ad0b5;}
.classify li:nth-child(12) .iconfont{ color: #feabc4;}
.classify li:nth-child(13) .iconfont{ color: #f8534f;}
.classify li:nth-child(14) .iconfont{ color: #3dd4f3;}
.classify li:nth-child(15) .iconfont{ color: #674cf1;}
.classify li:nth-child(16) .iconfont{ color: #f7a400;}
.classify li:nth-child(17) .iconfont{ color: #cb3af7;}
.classify li:nth-child(18) .iconfont{ color: #00d5af;}
.classify li:nth-child(19) .iconfont{ color: #fac100;}
</style>



// WEBPACK FOOTER //
// src/pages/list/components/Icons.vue